// extracted by mini-css-extract-plugin
export default {"moreButton":"L46W1pSBWF"};